import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
    FormInput,
} from 'wanderu-component-form';

import InputDropdown from '../../InputDropdown/InputDropdown';
import Options from '../../Options/Options';
import TabContext from '../TabContext';

import styles from './TabListDropdown.scss';

function TabListDropdown(props) {
    const {
        className,
        tabOptions,
    } = props;

    return (
        <TabContext.Consumer>
            {({ activeId, onChange }) => {
                const activeTab = tabOptions.find((tab) => (
                    tab.id === activeId
                ));

                function _onChange(e) {
                    let tab = e.target.value || {};
                    onChange(tab.id);
                }

                return (
                    <InputDropdown
                        className={classNames(className, styles.dropdownSelector)}
                        onChange={_onChange}
                        options={tabOptions}
                        value={activeTab.text}
                    >
                        <FormInput
                            clearable={false}
                            inputClassName={styles.formInput}
                            readOnly
                            showInputCaret
                        />
                        <Options
                            className={styles.options}
                            showOptionsCaret
                        >
                        </Options>
                    </InputDropdown>
                );
            }}
        </TabContext.Consumer>
    );
}

TabListDropdown.propTypes = {
    tabOptions: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        text: PropTypes.string,
    })).isRequired,
};

export default TabListDropdown;
